/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.installs.rpc.MarketplaceInstallsSecureInstallComplianceRpc
 */
import { createRpcClientV2 } from 'rpc-client-utils';
import { registerQuery, registerMutation } from 'data-fetching-client/next';
import http from 'hub-http/clients/apiClient';
import * as References from './MarketplaceInstallsSecureInstallComplianceRpc';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.installs.rpc.MarketplaceInstallsSecureInstallComplianceRpc#addNonCompliantListing
 */
export const ADD_NON_COMPLIANT_LISTING_MUTATION_FIELD_NAME = 'com_hubspot_marketplace_installs_rpc_MarketplaceInstallsSecureInstallComplianceRpc_addNonCompliantListing';
export const ADD_NON_COMPLIANT_LISTING_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: ADD_NON_COMPLIANT_LISTING_MUTATION_FIELD_NAME,
  args: ['listingId'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.addNonCompliantListingRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.installs.rpc.MarketplaceInstallsSecureInstallComplianceRpc#addNonCompliantListingsBatch
 */
export const ADD_NON_COMPLIANT_LISTINGS_BATCH_MUTATION_FIELD_NAME = 'com_hubspot_marketplace_installs_rpc_MarketplaceInstallsSecureInstallComplianceRpc_addNonCompliantListingsBatch';
export const ADD_NON_COMPLIANT_LISTINGS_BATCH_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: ADD_NON_COMPLIANT_LISTINGS_BATCH_MUTATION_FIELD_NAME,
  args: ['listingIds'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.addNonCompliantListingsBatchRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.installs.rpc.MarketplaceInstallsSecureInstallComplianceRpc#removeNonCompliantListing
 */
export const REMOVE_NON_COMPLIANT_LISTING_MUTATION_FIELD_NAME = 'com_hubspot_marketplace_installs_rpc_MarketplaceInstallsSecureInstallComplianceRpc_removeNonCompliantListing';
export const REMOVE_NON_COMPLIANT_LISTING_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: REMOVE_NON_COMPLIANT_LISTING_MUTATION_FIELD_NAME,
  args: ['listingId'],
  fetcher(request, ctx) {
    var _ctx$customClient3;
    return ((_ctx$customClient3 = ctx.customClient) !== null && _ctx$customClient3 !== void 0 ? _ctx$customClient3 : chirpClient).call(References.removeNonCompliantListingRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.installs.rpc.MarketplaceInstallsSecureInstallComplianceRpc#removeNonCompliantListingsBatch
 */
export const REMOVE_NON_COMPLIANT_LISTINGS_BATCH_MUTATION_FIELD_NAME = 'com_hubspot_marketplace_installs_rpc_MarketplaceInstallsSecureInstallComplianceRpc_removeNonCompliantListingsBatch';
export const REMOVE_NON_COMPLIANT_LISTINGS_BATCH_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: REMOVE_NON_COMPLIANT_LISTINGS_BATCH_MUTATION_FIELD_NAME,
  args: ['listingIds'],
  fetcher(request, ctx) {
    var _ctx$customClient4;
    return ((_ctx$customClient4 = ctx.customClient) !== null && _ctx$customClient4 !== void 0 ? _ctx$customClient4 : chirpClient).call(References.removeNonCompliantListingsBatchRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.installs.rpc.MarketplaceInstallsSecureInstallComplianceRpc#getSecureInstallCompliance
 */
export const GET_SECURE_INSTALL_COMPLIANCE_QUERY_FIELD_NAME = 'com_hubspot_marketplace_installs_rpc_MarketplaceInstallsSecureInstallComplianceRpc_getSecureInstallCompliance';
export const GET_SECURE_INSTALL_COMPLIANCE_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_SECURE_INSTALL_COMPLIANCE_QUERY_FIELD_NAME,
  args: ['listingId'],
  fetcher(request, ctx) {
    var _ctx$customClient5;
    return ((_ctx$customClient5 = ctx.customClient) !== null && _ctx$customClient5 !== void 0 ? _ctx$customClient5 : chirpClient).call(References.getSecureInstallComplianceRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});